const SocialIcon = ({ href, label, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
      {children}
    </a>
);

export default SocialIcon;